<template>
<div class="ql-nav-layer-picker">
    <h2 class="md-title">Active Layer</h2>
    <md-menu ref="layerMenu" md-size="6">
        <md-button md-menu-trigger class="pick-current-layer" :style="{backgroundColor: currentLayer.color}" v-if="currentLayer">
            <!-- <md-tooltip md-direction="top">Click to change layer</md-tooltip> -->
        </md-button>
        <md-button md-menu-trigger class="blank-current-layer" v-else>
            <md-tooltip md-direction="right">Please choose an active layer.</md-tooltip>
        </md-button>
        <span class="current-layer-name" v-if="currentLayer">{{currentLayer.title}}</span>
        <span class="current-layer-name" v-else>Select an active layer</span>
        <md-menu-content>
            <md-menu-item v-for="layer in layers" :key="layer.id" @selected="selectLayer(layer)">
                <span class="ql-nav-layer-picker-item" :style="style(layer)"></span>
                <span class="ql-nav-layer-picker-option">{{layer.title}}</span>
            </md-menu-item>
        </md-menu-content>
    </md-menu>
</div>
</template>

<script>
const LayersLayerPicker = {
    name: 'LayersLayerPicker',
    props: ['layers', 'currentLayer'],
    data: function() {
        return {
        };
    },
    methods: {
        style(layer) {
            const val = 'background-color: ' + layer.color + ' !important;';
            return val;
        },
        open() {
            this.$refs.layerMenu.open();
        },
        selectLayer(layer) {
            this.$store.dispatch('setEditingLayer', layer);
        }
    }
};

export default LayersLayerPicker;
</script>

<style>
.ql-nav-layer-picker {
    padding: 1em;
}

.ql-nav-layer-picker-item {
    padding: 1em;
    border: 1px solid black;
}

.ql-nav-layer-picker-option {
    margin-left: 48px;
}

.current-layer-name {
    display: inline-block;
    font-size: 16px;
    padding-top: 5px;
    margin-left: 10px;
}

.pick-current-layer, .blank-current-layer {
    padding: 0;
    margin: 0;
    border: 1px solid black;
    min-width: 25px;
    width: 25px;
    min-height: 25px;
    height: 25px;
}

.blank-current-layer {
    background-color: white;
}
</style>


// WEBPACK FOOTER //
// layer-picker.vue?0626409b